import { writable } from 'svelte/store';

// Booking Payment Information
export const information = writable({
  totalAmount: 0,
  individualAmount: 0,
  totalTaxes: 0,
  deposit: 0,
  people: 1,
  gratuity: 0,
  addonsPrice: 0,
  show: false,
  corkageAmount: 0,
});
